import productImage1 from "./product-image1.png";
import productImage2 from "./product-image2.png";
import productImage3 from "./product-image3.png";

export const newProductImages = {
  productImage1,
  productImage2,
  productImage3,
};
